import { render, staticRenderFns } from "./ServicesCategoriesAboutHeader.vue?vue&type=template&id=567197e1&"
import script from "./ServicesCategoriesAboutHeader.vue?vue&type=script&lang=js&"
export * from "./ServicesCategoriesAboutHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports